import * as React from 'react';

import * as styles from './MoneySourceTabs.css';

import { IMoneySourceProps } from '../../types';
import { EMoneySource } from '../../../../types/reducers/user';
import { MoneySourceTab } from './MoneySourceTab';

interface IProps {
  options: Array<IMoneySourceProps>;
  onChange: (value: EMoneySource) => void;
}

export const MoneySourceTabs = ({ options, onChange }: IProps) => (
  <div className={styles['wrapper']}>
    {options.map(({ disabled, active, label, value }) => (
      <MoneySourceTab disabled={disabled} active={active} onChange={onChange} label={label} value={value} key={value} />
    ))}
  </div>
);
